import { classNames } from "primereact/utils";

import { positionStyle, resolveGanttLayout } from "./gantt-layout";
import styles from "./gantt.module.scss";
import type { GanttBarProps, GanttBarViewModel } from "./types-gantt";

/** ViewModel da `GanttBar`: posição em % e pela faixa do layout, classes e atributos; sem JSX. */
export function useGanttBar({
  start,
  end,
  tone,
  label,
  variant = "solid",
  lane = 0,
  layout,
  past,
  onClick,
  testId,
  className,
  style,
  classNames: parts,
  "aria-label": ariaLabel,
  ...rest
}: GanttBarProps): GanttBarViewModel {
  const resolved = resolveGanttLayout(layout);

  return {
    className: classNames(styles.bar, styles[variant], className),
    labelClassName: classNames(styles.label, parts?.label),
    style: { ...positionStyle(resolved, { start, end }, lane), ...style },
    tone,
    variant,
    dataPast: past || undefined,
    lane,
    testId,
    ariaLabel,
    label,
    onClick,
    rest,
  };
}
